<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <DefaultTmpl :mode="$appUtils.isMobile() ? 'mobile_search' : 'default'">
        <template v-slot:main>
            <div v-if="isUserProfileScreen">
                <head-utils title="Meu Perfil"/>
                <breadcrumb
                        :items="[{label: 'Meu Perfil', path: '/users/profile'}]"/>
            </div>
            <div v-else>
                <head-utils :title="entity.id ? `Alterar ${entity.name}` : 'Criar Novo Usuário'"/>
                <breadcrumb
                        :items="[{label: 'Pesquisa de Usuários', path: '/users'}, {label: 'Criar Usuário', path: '/users/new'}]"/>
            </div>

            <form @submit.prevent.stop="saveData" novalidate>
                <ibox type="tab_right">
                    <template v-slot:title v-if="!$appUtils.isMobile()">
                        <h5>Dados do {{isUserProfileScreen ? 'Meu Perfil' : 'Usuário'}}</h5>
                    </template>

                    <template v-slot:tabs>
                        <Tabs :tabs="tabs" @onTabSelected="onTabSelected"/>
                    </template>

                    <template v-slot:content>
                        <transition name="tab" mode="out-in">
                            <GeneralTab
                                    :entity="entity"
                                    :errors="errors"
                                    :key="'general_tab'"
                                    :is-user-profile-screen="isUserProfileScreen()"
                                    v-if="currentTab === 0"/>

                            <NotificationTab
                                    :key="'notification_tab'"
                                    v-if="currentTab === 1"/>
                            <ProposalsTab
                                    :entity="entity"
                                    :key="'proposals_tab'"
                                    v-if="currentTab === 2 && isBrokerProfile"/>
                            <FinancialMovementsTab
                                    :entity="entity"
                                    :key="'financial_movements_tab'"
                                    v-if="currentTab === 3 && isBrokerProfile"/>
                            <AssistantTab
                                    :key="'assistant_tab'"
                                    v-if="currentTab === assistantTabIndex"/>
                        </transition>
                    </template>
                    <template v-slot:footer>
                        <div class="container-fluid-grid">
                            <div class="row">
                                <div class="col t-r">
                                    <div class="btn-group btn-group-sm" role="group" aria-label="Comandos de Pesquisa">
                                        <button type="button" @click="reset" class="btn btn-secondary btn-sm"><svg-icon icon="sync"/> Limpar</button>
                                        <router-link to="/users" class="btn btn-dark btn-sm"><svg-icon icon="search"/> Pesquisar</router-link>
                                        <button type="submit" class="btn btn-theme-1 btn-sm"><svg-icon icon="save"/> Salvar</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </template>
                </ibox>
            </form>
        </template>
        <template v-slot:footer>
            <BottomMenuMob v-if="$appUtils.isMobile() && isUserProfileScreen"/>
        </template>
    </DefaultTmpl>
</template>

<script>
    import CRUDEdit from '@/mixins/CRUDEdit'
    import BottomMenuMob from "../../components/particles/BottomMenuMob";
    import Tabs from "../../components/particles/Tabs";
    import GeneralTab from "./GeneralTab";
    import {createNamespacedHelpers} from 'vuex'
    import ProposalsTab from "./ProposalsTab";
    import FinancialMovementsTab from "./FinancialMovementsTab";
    import {humanizeNumber} from "../../utils/Utils";
    import NotificationTab from "./NotificationTab";
    import AssistantTab from "./AssistantTab";

    const {mapGetters, mapActions} = createNamespacedHelpers('users');

    export default {
        name: "UsersEdit",
        components: {AssistantTab, NotificationTab, FinancialMovementsTab, ProposalsTab, GeneralTab, BottomMenuMob, Tabs},
        mixins: [
            CRUDEdit.mount('users')
        ],
        data() {
            return {
                tabs: [{
                    icon: 'info-circle',
                    label: 'Dados Gerais',
                    active: true
                },{
                    icon: 'info-circle',
                    label: 'Notificações',
                    active: false
                }],
                currentTab: 0,
                errors: {},
                // Índice da aba "Assistente de IA" — só existe no próprio perfil; -1
                // significa "não montada" (nunca casa com currentTab).
                assistantTabIndex: -1,
            }
        },
        methods: {
            ...mapActions(['updateProfile']),
            onTabSelected(tab) {
                this.currentTab = tab.index;
            },
            updateTabBadges() {
                if (this.isBrokerProfile) {
                    const proposals = this.entity.proposals_count;
                    const fins = this.entity.financial_movements_count;

                    this.$set(this.tabs, 2, {...this.tabs[2], badge: (proposals > 0) ? humanizeNumber(proposals) : null});
                    this.$set(this.tabs, 3, {...this.tabs[3], badge: (fins > 0) ? humanizeNumber(fins) : null});
                }
            },
            createEntity() {
                this.entity = {
                    profile: 'broker',
                    email: '',
                    name: '',
                }
            },
            onLoadSuccess(entity) {
                Object.keys(entity).forEach(k => {
                    let val = null;
                    if (/(_at|_birth)$/.test(k)) val = this.$appUtils.formatDate(entity[k]);
                    else val = entity[k];
                    this.$set(this.entity, k, val);
                });

                this.updateTabBadges();
            },
            isUserProfileScreen() {
                return this.$router.currentRoute.name === 'usersProfile'
            },
            saveData() {
                if (this.isUserProfileScreen) {
                    this.errors = {};
                    this.updateProfile(this.entity)
                        .then(() => {
                            this.errors = {};
                            this.$snotify.success('Perfil alterado com sucesso.', this.$appStorage.getUser().name);
                            this.changePassword = false;
                            this.$set(this.entity, 'password_digest', null);
                            this.$set(this.entity, 'new_pass', null);
                            this.$set(this.entity, 'new_pass_confirm', null);
                        })
                        .catch(({response}) => {
                            this.$appUtils.vibrate();

                            if (response.status === 422) {
                                Object.keys(response.data).forEach(k => {
                                    this.$set(this.errors, k, response.data[k]);
                                });
                                this.$snotify.warning('Verifique os dados informados', 'Validação');
                            } else if (response.status === 403) {
                                this.$snotify.error('Você não possui permissão para executar essa ação', 'Permissão')
                            } else {
                                this.$snotify.error('Ops... Aconteceu algum problema inesperado. Tente novamente e caso o problema persista, contate o suporte.', 'Falha')
                            }
                        });
                } else this.submit();
            }
        },
        computed: {
            ...mapGetters(['userSession']),
            isBrokerProfile() {
                return 'profile' in (this.userSession || {}) && /(admin_all|admin_view|broker)/.test(this.userSession.profile)
            }
        },
        mounted() {
            if (this.isBrokerProfile) {
                this.tabs.push({
                    icon: 'handshake',
                    label: 'Meus Contratos',
                    active: false
                }, {
                    icon: 'cash-register',
                    label: 'Meus Pagamentos',
                    active: false
                })
            }

            // Consentimento do assistente de IA: aba só no próprio perfil (flags
            // pessoais no localStorage). O índice é dinâmico porque as abas de broker
            // acima podem ou não existir.
            if (this.isUserProfileScreen()) {
                this.tabs.push({
                    icon: 'robot-solid',
                    label: 'Assistente de IA',
                    active: false
                });
                this.assistantTabIndex = this.tabs.length - 1;
            }

            if (this.isUserProfileScreen) {
                this.load(this.userSession.id)
                    .then(this.onLoadSuccess)
                    .catch(console.error);
            }
        }
    }
</script>
